export const ORDER_URL = "https://waiterman.ai/northgateflavou/order";
export const RESERVE_URL = "https://waiterman.ai/northgateflavou/book";
export const PHONE = "61 431 264 820";
export const PHONE_LINK = "tel:+61431264820";
export const ADDRESS = "203 Toombul Rd, Northgate QLD 4013, Australia";
export const MAP_EMBED =
  "https://www.google.com/maps?q=203+Toombul+Rd,+Northgate+QLD+4013,+Australia&output=embed";

// minutes from midnight, [open, close] — null = closed (Australia/Brisbane)
export const HOURS_MINUTES = {
  0: null,
  1: [690, 1200],
  2: [690, 1260],
  3: [690, 1260],
  4: [690, 1260],
  5: [900, 1350],
  6: [900, 1320],
};

export const HOURS_DISPLAY = [
  { day: "Monday", time: "11:30 am – 8:00 pm", jsDay: 1 },
  { day: "Tuesday", time: "11:30 am – 9:00 pm", jsDay: 2 },
  { day: "Wednesday", time: "11:30 am – 9:00 pm", jsDay: 3 },
  { day: "Thursday", time: "11:30 am – 9:00 pm", jsDay: 4 },
  { day: "Friday", time: "3:00 pm – 10:30 pm", jsDay: 5 },
  { day: "Saturday", time: "3:00 pm – 10:00 pm", jsDay: 6 },
  { day: "Sunday", time: "Closed", jsDay: 0 },
];

export function getOpenState() {
  const now = new Date(
    new Date().toLocaleString("en-US", { timeZone: "Australia/Brisbane" })
  );
  const day = now.getDay();
  const mins = now.getHours() * 60 + now.getMinutes();
  const today = HOURS_MINUTES[day];
  if (today && mins >= today[0] && mins < today[1]) {
    const closeH = Math.floor(today[1] / 60);
    const closeM = today[1] % 60;
    const close = new Date(now);
    close.setHours(closeH, closeM, 0, 0);
    return {
      open: true,
      label: `Open now · closes ${close.toLocaleTimeString("en-AU", { hour: "numeric", minute: "2-digit" })}`,
    };
  }
  // find next opening
  for (let i = 0; i < 8; i++) {
    const d = (day + i) % 7;
    const range = HOURS_MINUTES[d];
    if (!range) continue;
    if (i === 0 && mins >= range[0]) continue;
    const open = new Date(now);
    open.setDate(now.getDate() + i);
    open.setHours(Math.floor(range[0] / 60), range[0] % 60, 0, 0);
    const dayName = i === 0 ? "today" : i === 1 ? "tomorrow" : open.toLocaleDateString("en-AU", { weekday: "long" });
    return {
      open: false,
      label: `Closed · opens ${dayName} ${open.toLocaleTimeString("en-AU", { hour: "numeric", minute: "2-digit" })}`,
    };
  }
  return { open: false, label: "Closed" };
}

export const MENU = [
  {
    id: "appetizers",
    label: "Appetizers",
    items: [
      { name: "Veg Samosa", note: "2 pcs", desc: "Come with tamarind sauce", price: "7.80" },
      { name: "Onion Bhaji", note: "4 pcs", desc: "Deep fried onions with spices & chickpea flour", price: "8.84" },
      { name: "Veg Spring Rolls", note: "4 pcs", desc: "Deep fried, comes with tamarind sauce", price: "8.27" },
      { name: "Chicken Tikka", note: "6 pcs", desc: "Boneless marinated chicken, comes with mint sauce", price: "16.12" },
      { name: "Pappadum Platter", note: "6 pcs", desc: "Crispy pappadums with 3 different dips", price: "8.27" },
    ],
  },
  {
    id: "paneer",
    label: "Paneer Curries",
    items: [
      { name: "Paneer Muttar", desc: "Cottage cheese cooked with green peas in a rich onion & tomato sauce", price: "18.20" },
      { name: "Palak Paneer", desc: "Fresh ground spinach & spices with home cottage cheese", price: "18.20" },
      { name: "Paneer Tikka Masala", desc: "Cottage cheese cubes, onions & capsicum in masala sauce", price: "18.20" },
      { name: "Kadhai Paneer", desc: "Cottage cheese cooked with ginger, onion, capsicum & spices", price: "18.20" },
      { name: "Paneer Makhani", desc: "Cottage cheese simmered in a rich tomato based gravy finished with cream", price: "18.20" },
    ],
  },
  {
    id: "chicken",
    label: "Chicken Curries",
    items: [
      { name: "Mango Chicken", desc: "Chicken cooked with mild creamy mango and almond sauce", price: "19.24" },
      { name: "Butter Chicken", desc: "Roasted succulent chicken pieces simmered in a rich tomato and creamy gravy", price: "19.24", tag: "House favourite" },
      { name: "Chicken Tikka Masala", desc: "Chicken cooked with onions, capsicum in onion and tomato sauce", price: "19.24" },
      { name: "Chicken Chef Curry", desc: "Chicken cooked with onions & fresh tomato finished with Indian spices", price: "19.24" },
      { name: "Chicken Saagwala", desc: "Chicken cooked with freshly ground spinach with spices", price: "19.24" },
      { name: "Chicken Korma", desc: "Mild spice curry in almond and onion sauce", price: "19.24" },
      { name: "Chicken Vindaloo", desc: "Hot & spicy sauce made with red chilli & spices", price: "19.24", tag: "Hot" },
      { name: "Kadhai Chicken", desc: "Cooked in traditional kadhai with capsicum, onions, tomato, garlic & spices", price: "19.24" },
    ],
  },
  {
    id: "beef",
    label: "Beef Curries",
    items: [
      { name: "Beef Rogan Josh", desc: "Classic north Indian curry cooked with ground spices and herbs", price: "19.71" },
      { name: "Beef Vindaloo", desc: "Hot & spicy sauce made with red chillies & spices", price: "19.71", tag: "Hot" },
      { name: "Beef Korma", desc: "Mild spice curry in almond and onion sauce finished with cream", price: "19.71" },
      { name: "Beef Madras", desc: "Spicy south Indian curry infused with coconut sauce and spices", price: "19.71" },
      { name: "Beef Saagwala", desc: "Meat cooked with freshly ground spinach, onion tomato & spices", price: "19.71" },
    ],
  },
  {
    id: "lamb",
    label: "Lamb Curries",
    items: [
      { name: "Lamb Rogan Josh", desc: "Classic north Indian curry cooked with ground spices and herbs", price: "20.75" },
      { name: "Lamb Vindaloo", desc: "Hot & spicy sauce made with red chillies & spices", price: "20.75", tag: "Hot" },
      { name: "Lamb Korma", desc: "Mild spice curry in almond and onion sauce finished with cream", price: "20.75" },
      { name: "Lamb Madras", desc: "Spicy south Indian curry infused with coconut sauce and spices", price: "20.75" },
      { name: "Lamb Saagwala", desc: "Meat cooked with freshly ground spinach, onion tomato & spices", price: "20.75" },
    ],
  },
  {
    id: "vegetarian",
    label: "Vegetarian",
    items: [
      { name: "Vegetable Korma", desc: "Mix vegetables with mild cashew & almond sauce", price: "17.16" },
      { name: "Channa Masala", desc: "Chickpeas cooked in tomato & onion sauce with ground spices", price: "17.16" },
      { name: "Dhal Makhani", desc: "Black lentils & red kidney beans slow cooked with spices, butter & cream", price: "17.16" },
      { name: "Tadka Dhal", desc: "Traditional tempered dhal cooked with garlic, onion, tomato & spices", price: "17.16" },
      { name: "Malai Kofta", desc: "Kofta in a curry made from fenugreek leaves & special spices in a cashew nut sweetened sauce", price: "17.16" },
      { name: "Mixed Vegetables", desc: "A medley of vegetables cooked in ginger, garlic & onion sauce", price: "17.16" },
    ],
  },
  {
    id: "biryani",
    label: "Tawa Biryani",
    items: [
      { name: "Paneer Biryani", desc: "A traditional rice dish garnished with fried onions and served with raita", price: "18.20" },
      { name: "Vegetables Biryani", desc: "A traditional rice dish garnished with fried onions and served with raita", price: "17.16" },
      { name: "Lamb Biryani", desc: "A traditional rice & meat dish garnished with fried onions and served with raita", price: "19.24" },
      { name: "Chicken Tikka Biryani", desc: "A traditional rice & meat dish garnished with fried onions and served with raita", price: "18.20" },
    ],
  },
  {
    id: "breads",
    label: "Breads",
    items: [
      { name: "Spinach & Cheese Naan", desc: "", price: "6.76" },
      { name: "Kashmiri Naan", desc: "Coconut and sultana", price: "6.76" },
      { name: "Onion Naan", desc: "Onion, cheese and spices", price: "6.24" },
      { name: "Punjabi Naan", desc: "Chicken, cheese and spices", price: "6.76" },
      { name: "Chilli & Cheese Naan", desc: "", price: "6.24" },
      { name: "Cheese Naan", desc: "", price: "6.24" },
      { name: "Garlic & Cheese Naan", desc: "", price: "6.24" },
      { name: "Garlic Naan", desc: "", price: "5.15" },
      { name: "Plain Naan", desc: "", price: "4.68" },
      { name: "Roti", desc: "", price: "4.16" },
    ],
  },
  {
    id: "rice",
    label: "Rice",
    items: [
      { name: "Steamed Rice", desc: "", price: "3.12" },
      { name: "Zeera Rice", desc: "", price: "4.68" },
      { name: "Coconut Rice", desc: "", price: "6.24" },
      { name: "Lemon Coconut Rice", desc: "", price: "7.28" },
    ],
  },
  {
    id: "desserts",
    label: "Desserts",
    items: [
      { name: "Gulab Jamun", note: "2 pcs", desc: "", price: "4.16" },
      { name: "Mango Lassi", desc: "", price: "6.24" },
    ],
  },
  {
    id: "drinks",
    label: "Drinks",
    items: [
      { name: "Can", desc: "Coca Cola, Lemonade", price: "3.64" },
      { name: "Ginger Beer", desc: "", price: "4.68" },
      { name: "Coca Cola 1.25 Ltr", desc: "", price: "5.72" },
    ],
  },
  {
    id: "deep-fried",
    label: "Deep Fried",
    items: [
      { name: "Beef Dim Sim", note: "each", desc: "", price: "3.12" },
      { name: "Chicken Dim Sim", note: "each", desc: "", price: "3.12" },
      { name: "Garlic Ball", note: "each", desc: "", price: "3.64" },
      { name: "Wing Ding", note: "each", desc: "", price: "3.64" },
      { name: "Pork Crumbed Sausage", note: "each", desc: "", price: "5.20" },
      { name: "Chicken Chips", note: "8 pcs", desc: "", price: "6.24" },
      { name: "Veg Spring Roll", note: "each", desc: "", price: "2.08" },
      { name: "Vegetable Samosa", note: "each", desc: "", price: "3.64" },
    ],
  },
];
